export default class Constants {
	static STEPS = {
		STEP1: 'PRODUCT_SELECTION',
		STEP2: 'CONTACT',
		STEP3: 'SUMMARY',
		STEP4: 'LEGAL',
		STEP5: 'SUCCESS',
		LOGIN: 'LOGIN'
	};

	static STEPS_ORDER = [
		Constants.STEPS.STEP1,
		Constants.STEPS.STEP2,
		Constants.STEPS.STEP3,
		Constants.STEPS.STEP4,
		Constants.STEPS.STEP5
	];

	static MAX_STEPS = Constants.STEPS_ORDER.length;
}
